import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const REPORTS_HUB_PATH = '/raporlar';

export const REPORTS_HUB_STATE = { from: REPORTS_HUB_PATH };

const cameFromHub = (state: unknown): boolean =>
  (state as { from?: string } | null)?.from === REPORTS_HUB_PATH;

/**
 * Rapor Raporlar sayfasından açıldıysa geri butonu Raporlar'a döner; aksi halde fallback çalışır.
 * Sekme modunda bileşen açık kaldığı için bilgi state'te tutulur; yalnızca bu raporun
 * kendi yoluna yapılan geçişler dikkate alınır.
 */
export const useReportsHubBack = (reportPath: string, fallback?: () => void) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fromHub, setFromHub] = useState(
    () => location.pathname === reportPath && cameFromHub(location.state),
  );

  useEffect(() => {
    if (location.pathname === reportPath && cameFromHub(location.state)) {
      setFromHub(true);
    }
  }, [location.pathname, location.state, reportPath]);

  const goBack = useCallback(() => {
    if (fromHub || !fallback) {
      navigate(REPORTS_HUB_PATH);
      return;
    }
    fallback();
  }, [fromHub, fallback, navigate]);

  return { fromHub, goBack };
};
